<app-auth-layout>
  <div class="auth-card register"
    [class.auth-card--large]="currentStep == 4"
    >
    <h2>{{ 'register.title' | transloco }}</h2>

    <app-progress-bar [progress]="progressValue()"></app-progress-bar>

    <form [formGroup]="registerForm">
        @switch (currentStep) {
      <!-- Step 1: Basic Info -->
      @case (1) {
        <app-register-form-step name="register.step1.title">
          <div class="input-group">
            <label for="firstname">{{ 'register.firstname.label' | transloco }}</label>
            <input type="text" id="firstname" formControlName="firstname"
              [placeholder]="'register.firstname.placeholder' | transloco" />
            @if (registerForm.get('firstname')?.invalid && registerForm.get('firstname')?.touched) {
              <small class="error">
                {{ 'register.firstname.error' | transloco }}
              </small>
            }
          </div>
          <div class="input-group">
            <label for="lastname">{{ 'register.lastname.label' | transloco }}</label>
            <input type="text" id="lastname" formControlName="lastname"
              [placeholder]="'register.lastname.placeholder' | transloco" />
            @if (registerForm.get('lastname')?.invalid && registerForm.get('lastname')?.touched) {
              <small class="error">
                {{ 'register.lastname.error' | transloco }}
              </small>
            }
          </div>
          <div class="actions">
            <div></div>
            <button
              type="button"
              class="button button--large"
              [class.button--loading]="nextLoading"
              [disabled]="nextLoading || !registerForm.get('firstname')?.valid || !registerForm.get('lastname')?.valid"
              (click)="nextStep()"
              >
              {{ 'register.continue' | transloco }} <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </app-register-form-step>
      }
      <!-- Step 2: Role -->
      @case (2) {
        <app-register-form-step name="register.step2.title">
          <div class="roles-options">
            <button
              type="button"
              class="role-card"
              [class.role-card--selected]="role === UserRoles.photographer"
              (click)="selectRole(UserRoles.photographer)"
              >
              <span class="role-card__check" aria-hidden="true">
                <i class="fa-solid fa-check"></i>
              </span>
              <span class="role-card__icon" aria-hidden="true">
                <i class="fa-solid fa-camera-retro"></i>
              </span>
              <span class="role-card__title">{{'register.step2.roles.photographer.title'|transloco}}</span>
              <span class="role-card__description">{{'register.step2.roles.photographer.description'|transloco}}</span>
            </button>
            <button
              type="button"
              class="role-card"
              [class.role-card--selected]="role === UserRoles.customer"
              (click)="selectRole(UserRoles.customer)"
              >
              <span class="role-card__check" aria-hidden="true">
                <i class="fa-solid fa-check"></i>
              </span>
              <span class="role-card__icon" aria-hidden="true">
                <i class="fa-solid fa-user"></i>
              </span>
              <span class="role-card__title">{{'register.step2.roles.client.title'|transloco}}</span>
              <span class="role-card__description">{{'register.step2.roles.client.description'|transloco}}</span>
            </button>
          </div>
        </app-register-form-step>
        <div class="actions">
          <button
            type="button"
            class="button button--large button--white"
            (click)="prevStep()"
            >
            <i class="fa-solid fa-arrow-left"></i> {{ 'register.back' | transloco }}
          </button>
        </div>
      }
      <!-- Step 3: Login Info -->
      @case (3) {
        <app-register-form-step name="register.step3.title">
          <div class="input-group">
            <label for="email">{{ 'register.email.label' | transloco }}</label>
            <input type="email" id="email" formControlName="email"
              [placeholder]="'register.email.placeholder' | transloco" />
            @if (registerForm.get('email')?.invalid && registerForm.get('email')?.touched) {
              <small class="error">
                {{ 'register.email.error' | transloco }}
              </small>
            }
          </div>
          <div class="input-group">
            <label for="password">{{ 'register.password.label' | transloco }}</label>
            <input type="password" id="password" formControlName="password"
              [placeholder]="'register.password.placeholder' | transloco" />
            @if (registerForm.get('password')?.invalid && registerForm.get('password')?.touched) {
              <small class="error">
                {{ 'register.password.error' | transloco }}
              </small>
            }
          </div>
          <div class="input-group">
            <label for="passwordConfirm">{{ 'register.passwordConfirm.label' | transloco }}</label>
            <input type="password" id="passwordConfirm" formControlName="passwordConfirm"
              [placeholder]="'register.passwordConfirm.placeholder' | transloco" />
            @if (registerForm.hasError('passwordMismatch')) {
              <small class="error">
                {{ 'register.passwordConfirm.error' | transloco }}
              </small>
            }
          </div>
          <div class="actions">
            <button
              type="button"
              class="button button--large button--white"
              (click)="prevStep()"
              >
              <i class="fa-solid fa-arrow-left"></i> {{ 'register.back' | transloco }}
            </button>
            <button
              type="button"
              class="button button--large"
              [class.button--loading]="nextLoading"
              [disabled]="nextLoading || registerForm.get('email')?.invalid || registerForm.get('password')?.invalid || registerForm.hasError('passwordMismatch')"
              (click)="nextStep()"
              >
              {{ 'register.continue' | transloco }} <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </app-register-form-step>
      }
      <!-- Step 4: Plan Selection -->
      @case (4) {
        <app-register-form-step name="">
          <div class="subscription-cta">
            <p class="subscription-cta__plan">{{ 'register.step4.plan_name' | transloco }}</p>
            <p class="subscription-cta__subtitle">{{ 'register.step4.subtitle' | transloco }}</p>
            <div class="subscription-cta__comparison">
              <div class="comparison-table">
                <div class="comparison-table__header">
                  <span>{{ 'register.step4.table.feature' | transloco }}</span>
                  <span>{{ 'register.step4.table.free' | transloco }}</span>
                  <span>{{ 'register.step4.table.pro' | transloco }}</span>
                </div>
                <div class="comparison-table__viewport">
                  <div class="comparison-table__scroll">
                    <div class="comparison-table__group">
                      @for (row of comparisonRows; track row.key) {
                        <div class="comparison-table__row">
                          <span class="comparison-table__feature">
                            <i [class]="'fa-solid ' + comparisonIcons[row.key]" aria-hidden="true"></i>
                            <span>{{ row.key | transloco }}</span>
                          </span>
                          <span class="comparison-table__cell">
                            @if (row.free) { <i class="fa-solid fa-check"></i> }
                            @else { <i class="fa-solid fa-minus"></i> }
                          </span>
                          <span class="comparison-table__cell comparison-table__cell--pro">
                            @if (row.pro) { <i class="fa-solid fa-check"></i> }
                            @else { <i class="fa-solid fa-minus"></i> }
                          </span>
                        </div>
                      }
                    </div>
                    <div class="comparison-table__group" aria-hidden="true">
                      @for (row of comparisonRows; track $index) {
                        <div class="comparison-table__row">
                          <span class="comparison-table__feature">
                            <i [class]="'fa-solid ' + comparisonIcons[row.key]" aria-hidden="true"></i>
                            <span>{{ row.key | transloco }}</span>
                          </span>
                          <span class="comparison-table__cell">
                            @if (row.free) { <i class="fa-solid fa-check"></i> }
                            @else { <i class="fa-solid fa-minus"></i> }
                          </span>
                          <span class="comparison-table__cell comparison-table__cell--pro">
                            @if (row.pro) { <i class="fa-solid fa-check"></i> }
                            @else { <i class="fa-solid fa-minus"></i> }
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="subscription-cta__testimonial">
              <img
                class="subscription-cta__testimonial-avatar"
                ngSrc="assets/images/landing/gael.jpg"
                width="72"
                height="72"
                alt="Gael"
              />
              <div class="subscription-cta__testimonial-copy">
                <div class="subscription-cta__stars" aria-hidden="true">
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                  <i class="fa-solid fa-star"></i>
                </div>
                <p class="subscription-cta__quote">“{{ 'register.step4.testimonial.quote' | transloco }}”</p>
                <p class="subscription-cta__author">{{ 'register.step4.testimonial.author' | transloco }}</p>
              </div>
            </div>
            <div class="subscription-cta__social-proof">
              <div class="subscription-cta__avatars" aria-hidden="true">
                @for (avatar of socialAvatars; track avatar.src) {
                  <img
                    [ngSrc]="avatar.src"
                    width="28"
                    height="28"
                    [alt]="avatar.alt"
                  />
                }
              </div>
              <p class="subscription-cta__proof">{{ 'register.step4.social_proof' | transloco }}</p>
            </div>
          </div>
          <div class="actions actions--center">
            @if (canGoBack()) {
              <button
                type="button"
                class="button button--large button--secondary"
                (click)="prevStep()"
              >
                <i class="fa-solid fa-arrow-left"></i> {{ 'register.back' | transloco }}
              </button>
            }
            @else {
              <div></div>
            }
            <button
              type="button"
              class="button button--large"
              (click)="subscribe()"
              [class.button--loading]="nextLoading"
              [disabled]="nextLoading"
              >
              {{ 'register.step4.cta' | transloco }} <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
          <div class="subscription-cta__skip">
            <button type="button" class="button-link" (click)="skipSubscription()">
              {{ 'register.step4.skip' | transloco }}
            </button>
          </div>
        </app-register-form-step>
      }
    }

      </form>
  </div>
</app-auth-layout>
